// extracted by mini-css-extract-plugin
export var blue = "tag-module--blue--oUpSi";
export var dark = "tag-module--dark--C9-8K";
export var interactive = "tag-module--interactive--fBbIR";
export var light = "tag-module--light--xWboN";
export var red = "tag-module--red--QdHgl";
export var tag = "tag-module--tag--xEbcx";